module.exports = __webpack_public_path__ + "img/NoiseAware_Logo_Bug_Cream_on_Green.b6fbb1c9.png";